import { Scale } from "phaser";
import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ScaleManager from "../core/ScaleManager";
import { CharacterUnlockData } from "../game/MissionsState";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import Fonts from "../utils/Fonts";
import Overlay from "../utils/Overlay";

export class CharacterUnlockPopup extends GameObject {

	scene: GameScene;
	static ON_CLOSED = "onClosed";
    static isOpen: boolean;
	resize: () => void;
    charImg: Phaser.GameObjects.Image;
    header: Phaser.GameObjects.Image;
    headerText: Phaser.GameObjects.Text;
    descText: Phaser.GameObjects.Text;
    container: Phaser.GameObjects.Container;
    characterName: string;
    filmImage: Phaser.GameObjects.Image;
    onClose: () => void;
    context: CallbackContext;

    nextButton: Button;
	constructor(scene: GameScene, onClose?: () => void, context?: CallbackContext) {
		super(scene);
        if(onClose) this.onClose = onClose;
        if(context) this.context = context;
        CharacterUnlockPopup.isOpen = true;
		const saveData = PlayerData.Instance.saveData;
        const characterUnlocks = GameConfig.get<CharacterUnlockData[]>("characterUnlocks");

        let index = saveData.charactersUnlocked;
        this.characterName = characterUnlocks[index].name;

        const imageStr = `nextUnlockedCharLockedRecap`;
        console.log(`image: ${imageStr}`);
        this.setDepth(999);
		const overlay = this.addImage("missionsBG");
		ScaleManager.ScaleBackgroundFromZone(overlay, scene.viewport);
        overlay.setInteractive();
        overlay.visible = false;

		const popup = new GameObject(scene);
		this.add(popup);

		const starBurstSpine = scene.add.spine(0, 0, "star-burst", "starburst-idle", true);
        const starBurst = scene.add.spineContainer(0, 0, starBurstSpine);
        popup.add(starBurst);

        const container = this.container = scene.add.container(0, 0);
        popup.add(container);

		const characterImg = this.charImg = this.addImage(imageStr);
        container.add(characterImg);

        const header = this.header = this.addImage("recapCharHeader");
        container.add(header);

        const filmImg = this.filmImage = this.addImage("recapFilmImg");
        container.add(filmImg);

		const textStyle = {
			fontFamily: Fonts.MaliBoldItalic,
			color: "#352E9",
			fontSize: "36px",
			wordWrap: {width: 500},
			align: "center"
		};
        const headerText = this.headerText = scene.add.text(0, 0, Strings.get("NewCharacter"), {
            fontFamily: Fonts.LuckiestGuy,
			color: "#FFEDDF",
			fontSize: "70px",
            stroke: "#000000",
			strokeThickness: 5,
        });
        container.add(headerText);

        const descText = this.descText = scene.add.text(0, 0, Strings.get("NowAvailable").toUpperCase(), textStyle);
        container.add(descText);

		const nextButton = this.nextButton = scene.add.button(0, 0, "missionsNextBtn", undefined, () => {
            nextButton.disableInteractive();
            this.play();
        }, this, true);
		this.add(nextButton);
        nextButton.setVisible(false);
		// scene.alignIn.BottomRight(nextButton, overlay, 20, -20);
		// scene.alignIn.TopCenter(nextText, nextButton, 0, 50);

		this.resize = () => {
			overlay.setSize(scene.viewport.width, scene.viewport.height);
			//scene.alignIn.Center(this.textContainer, scene.viewport);
			overlay.setDisplaySize(scene.viewport.width, scene.viewport.height);
			const scale = Math.min(scene.viewport.width / (characterImg.width + 450), 1);
			popup.scale = scale;
            scene.alignIn.Center(characterImg, scene.viewport, -scene.viewport.width / 2, (-scene.viewport.height / 2) -90);
			scene.alignIn.BottomRight(nextButton, overlay, -20, -20);
            scene.alignIn.BottomCenter(header, characterImg, 0, 175);
            scene.alignIn.Center(headerText, header, 0, -25);
            scene.alignIn.BottomCenter(descText, header, 0, -5);
            scene.alignIn.BottomRight(filmImg, this.charImg, 55, 25);

		};

		scene.addResize(this.resize);
		scene.resize();
        this.build();
        setTimeout(() => {
            this.unlock();
        }, 1200);

	}

    build(): void{
        this.container.scale = 0;
        this.container.angle = -30;
        this.scene.tweens.add({
            targets: this.container, 
            scale: 1,
            angle: 0,
            duration: 400,
            ease: Phaser.Math.Easing.Back.Out,
        });

        this.scene.tweens.add({
            targets: this.container, 
            x: 20,
            delay: 800,
            duration: 50,
            yoyo: true,
            repeat: 3,
            ease: Phaser.Math.Easing.Linear,
        });
    }

	unlock(): void{
        this.nextButton.setScale(0);

		const timeline = this.scene.tweens.createTimeline();
        timeline.add({
            targets: this.container,
            scale: 0.5,
            angle: 10,
            duration: 300,
            ease: Phaser.Math.Easing.Linear,
            onComplete: () => {
                this.filmImage.setVisible(false);
                if (this.characterName.includes("lola")) {
                    this.headerText.setText(Strings.get("LolaUnlock").toUpperCase());
                }
                else if (this.characterName.includes("bugs")) {
                    this.headerText.setText(Strings.get("BugsUnlock").toUpperCase());
                }
                else if (this.characterName.includes("daffy")) {
                    this.headerText.setText(Strings.get("DaffyUnlock").toUpperCase());
                }
                else if (this.characterName.includes("tweety")) {
                    this.headerText.setText(Strings.get("TweetyUnlock").toUpperCase());
                }
                this.scene.alignIn.Center(this.headerText, this.header, 0, -25);
                this.scene.soundManager.play("characterUnlocked");

                this.charImg.setTexture(`nextUnlockedCharRecap`);

            }
        });

        timeline.add({
            targets: this.container, 
            scale: 1,
            angle: 0,
            duration: 300,
            ease: Phaser.Math.Easing.Back.Out,
            onComplete: () =>{
                this.nextButton.setVisible(true);
            }
        });
        timeline.add({
            targets: this.nextButton,
            scale: 1,
            duration: 250,
            ease: Phaser.Math.Easing.Back.Out
        });
		timeline.play();

	}

	destroy(): void {
        this.emit(CharacterUnlockPopup.ON_CLOSED);
        CharacterUnlockPopup.isOpen = false;
        if(this.onClose)this.onClose.call(this.onClose, this.context);
		this.scene.removeResize(this.resize);
		super.destroy();
	}

	play(): void {
        this.scene.tweens.add({
            targets: this.container, 
            scale: 0,
            angle: 15,
            duration: 400,
            ease: Phaser.Math.Easing.Back.In,
            onComplete: () => this.destroy(),
        });

        this.scene.tweens.add({
            targets: this.nextButton, 
            scale: 0,
            duration: 200,
            ease: Phaser.Math.Easing.Back.In,
        });
	}

}